import NoDataComponent from "../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const material_terms_no_data = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Material Terms of Employment"
      subheaderinfo="Material Terms of Employment will appear here"
    />
  );
};

export default material_terms_no_data;